export interface TimelineSpan {
    id: string
    tick?: string

    wt: number
    excl_wt: number
    cat: string
    cs: number
    hasBottleneck?: boolean
    bottlenecks?: string[]
    ms?: number
    mc?: number
    name: string
    summary?: string
    e?: TimeLineEvent[]
    annotations?: { [name: string]: any }
    stack?: StackCall[]

    ec?: number
    parent?: string
    parentTick?: string
    events?: { height: number; row?: (row: any) => void } | null
    sortIndex?: number
    type?: string
    span?: TimelineSpan
    fn?: string | null
    ct?: string | number
    perc_wt?: number
    perc_excl_wt?: number
    custom_type?: string

    spanId?: string
    relatedTraces?: Array<{ id: string; title: string }>

    async?: true
}

export interface StackCall {
    class?: string
    function: string
    file: string
    line: number
    type?: arrow
}

export interface TimeLineEvent {
    cs: number
    wt: number
    cat: string
    name: string
    row?: number
    active?: boolean
    span?: TimelineSpan
    ms?: number
    mc?: number
}

export interface TimelineSpanParent {
    span: TimelineSpan
    event?: TimeLineEvent
}

export const timelineSpanHasError = (span: TimelineSpan): boolean =>
    (span.annotations && 'err_exception' in span.annotations) || (span.ec || 0) > 0
export type arrow = '->'

interface StackObject {
    id: number
    end: number
}

export const flattenSpansEvents = (spans: TimelineSpan[]): TimelineSpan[] => {
    const mergedSpanData: TimelineSpan[] = []
    let mergedDataId = 0
    spans.forEach(span => {
        if (span.id) {
            span.excl_wt = span.wt
            span.sortIndex = mergedDataId
            span.type = 'span'
            mergedSpanData[mergedDataId] = span
            mergedDataId++
        }
        if (span.e) {
            span.e.forEach((event, index) => {
                const spanEvent: TimelineSpan = {
                    cs: event.cs,
                    wt: event.wt,
                    name: event.name,
                    type: 'event',
                    cat: event.cat,
                    id: span.id + index,
                    excl_wt: event.wt,
                    sortIndex: mergedDataId,
                    e: [],
                }
                mergedSpanData[mergedDataId] = spanEvent
                mergedDataId++
            })
        }
    })
    mergedSpanData.sort((a, b) => {
        if (a.cs < b.cs) {
            return -1
        }
        if (a.cs > b.cs) {
            return 1
        }
        return 0
    })
    const currentStack: StackObject[] = []
    let counter = 0
    mergedSpanData.forEach(spanEvent => {
        const time: number = spanEvent.cs + spanEvent.wt
        for (let j = currentStack.length - 1; j >= 0; j--) {
            if (currentStack[j].end >= time) {
                mergedSpanData[currentStack[j].id].excl_wt -= spanEvent.wt
                break
            } else {
                currentStack.pop()
            }
        }
        const stackobj = { id: counter, end: time }
        currentStack.push(stackobj)
        counter++
    })

    return mergedSpanData
}
